import axios, { AxiosResponse } from "axios";
import { Concurso, jornada, tipo_c, unidad } from "../components/Concurso";

//const API_BASE_URL = "https://localhost:5000";
const API_BASE_URL = "https://trabajosua.uantof.cl:5000";

const api = axios.create({
  baseURL: API_BASE_URL,
});

export const obtener_concurso = async (
  buscar: string,
  page: number,
  itemsPerPage: number,
  visible: boolean,
  contrato: tipo_c,
  jornada: jornada,
  unidad: unidad,
  max: number,
  min: number,
  cargo: string
): Promise<Concurso[]> => {
  try {
    const response: AxiosResponse<Concurso[]> = await api.get(
      `/api/concurso?buscar=${buscar}&page=${page}&itemsPerPage=${itemsPerPage}&visible=${visible}&contrato=${contrato.id}&jornada=${jornada.id}&unidad=${unidad.id}&max=${max}&min=${min}&cargo=${cargo}`
    );
    console.log(response.data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const obtener_cantidad_concurso = async (
  buscar: string,
  visible: boolean,
  contrato: tipo_c,
  jornada: jornada,
  unidad: unidad,
  max: number,
  min: number,
  cargo: string
): Promise<number> => {
  try {
    const response: AxiosResponse<number> = await api.get(
      `/api/cantidad_concurso?buscar=${buscar}&visible=${visible}&contrato=${contrato.id}&jornada=${jornada.id}&unidad=${unidad.id}&max=${max}&min=${min}&cargo=${cargo}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const ingresar_archivo = async (archivo: string) => {
  try {
    await api.post("/api/archivos", { archivo });
  } catch (error) {
    throw error;
  }
};

export const obtener_archivos = async (arch: number): Promise<Concurso[]> => {
  try {
    const response: AxiosResponse<Concurso[]> = await api.get(
      `/api/archivos_informacion?arch=${arch}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const obtener_jornada = async (): Promise<jornada[]> => {
  try {
    const response: AxiosResponse<jornada[]> = await api.get(`/api/jornada`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const obtener_tipo_contrato = async (): Promise<tipo_c[]> => {
  try {
    const response: AxiosResponse<tipo_c[]> = await api.get(
      `/api/tipo_contrato`
    );
    console.log(response.data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const obtener_unidad = async (): Promise<unidad[]> => {
  try {
    const response: AxiosResponse<unidad[]> = await api.get(`/api/unidad`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
